import { RawInput, useDisplayLabel } from '@ps/web-shared-components';
import type { LabelProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import styles from './FormatError.scss';

const { error } = RawInput.styles;

interface Props {
  errorMessage: LabelProp;
  className?: string;
}

const FormatError: React.FC<Props> = ({ errorMessage, className }) => {
  const message = useDisplayLabel(errorMessage);

  return <div className={classNames(styles.message, error, className)}>{message}</div>;
};

export default FormatError;
